import { History } from 'lucide-react'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '../../../components/ui/card'
import { formatMoneyValue } from '../../../../app/utils/formatMoneyValue'
import { lastTransactionTime } from '../../../../app/utils/lastTransactionTime'
import { formatDate } from '@/app/utils/formatDate'

type ClientCardProps = {
  _id: string
  name: string
  birthDate: string
  transactions: number
  value: number
  lastTransaction: string
  handleCustomerDetailsPage: (id: string) => void
}

export const ClientCard = ({
  _id,
  birthDate,
  handleCustomerDetailsPage,
  lastTransaction,
  name,
  transactions,
  value,
}: ClientCardProps) => {
  return (
    <div>
      <Card
        onClick={() => handleCustomerDetailsPage(_id)}
        className="min-h-[250px] cursor-pointer"
      >
        <CardHeader>
          <p className="font-semibold">{name}</p>
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium text-black04">
              Data de nascimento
            </p>
            <p className="text-sm font-medium">
              {birthDate ? formatDate(birthDate) : 'Não informado'}
            </p>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 px-3 py-2">
              <p className="font-semibold">{transactions}</p>
              <p className="text-xs font-medium text-black04">
                Saques realizados
              </p>
            </div>
            <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 px-3 py-2">
              <p className="font-semibold">{formatMoneyValue(value || 0)}</p>
              <p className="text-xs font-medium text-black04">Movimentados</p>
            </div>
          </div>
        </CardContent>
        <CardFooter>
          {lastTransaction ? (
            <div className="flex w-full items-center justify-center gap-1">
              <History size={22} />
              <p className="text-xs font-medium">Ultima movimentação: </p>
              <p className="text-xs font-medium text-black04">
                {' '}
                {lastTransaction ? lastTransactionTime(lastTransaction) : null}
              </p>
            </div>
          ) : null}
        </CardFooter>
      </Card>
    </div>
  )
}
